import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M420-695H245q-25 0-42-18-17-17-17-42t17-42q17-18 42-18h470q25 0 42 18 18 17 18 42t-18 42q-17 18-42 18H540v490q0 24-17 42-18 17-43 17t-42-17q-18-18-18-43v-489Z"/>',
  f: '<path d="M420-695H245q-25 0-42-18-17-17-17-42t17-42q17-18 42-18h470q25 0 42 18 18 17 18 42t-18 42q-17 18-42 18H540v490q0 24-17 42-18 17-43 17t-42-17q-18-18-18-43v-489Z"/>',
};

export default data;
